/**
 * @generated SignedSource<<e62545c8d16744764215f6eeb5fa685b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsSettingsPage_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PageWithBreadCrumbs_query">;
  readonly " $fragmentType": "NotificationsSettingsPage_query";
};
export type NotificationsSettingsPage_query$key = {
  readonly " $data"?: NotificationsSettingsPage_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationsSettingsPage_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationsSettingsPage_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageWithBreadCrumbs_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c04175fd91923fc5c2c75c6e28cbf756";

export default node;
